/* Imports */
import { sanitizeAnalyticsString } from '@garmin/analytics';

/**
 * Extracts and sanitizes the product family name from a product's name.
 * @param {string} productName - The display name of the product.
 * @returns {string}           - The sanitized product family name. Returns 'NA' if the `displayName` is not defined.
 */
export const productFamily = (productName) => sanitizeAnalyticsString(productName?.split(' ')[0]) || 'NA';

export default productFamily;
